module.exports = __webpack_public_path__ + "static/media/6_l_bord_4.84_0.56.86feb624.png";